import React, { useEffect, useState } from 'react';
import {connect, dispatch} from 'react-redux'

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios, {source} from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'

import { DeletedMerchantsTable } from '../../../components/Merchant';
import { CircularProgress, Backdrop, Card, CardHeader, Divider, AppBar, Tabs, Tab } from '@mui/material';
import { MerchantDeleteDialog } from '../../../components/Merchant';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  },
  active_tab: {
    color: '#fff!important',
    background: '#17507f'
  }
});

const DeletedMerchantList = props => {
  const classes = useClasses(styles);
  const { 
    onFetchMerchants,
    merchants,
    token,
    loading,
    pagination,
    modalOpen
  } = props

  const [page, setPage] = useState(0)
  const [per_page, setPerPage] = useState(25)
  const [search, setSearch] = useState('')
  const [delete_id, setDeleteId] = useState('')
  const [reason, setReason] = useState('')
  const [isFiltered, setIsFiltered] = useState(false)

  useEffect(() => {
    if (search) {
      setIsFiltered(true)
    }
    onFetchMerchants(page, per_page, search);
    
    return () => {
      source.cancel()
    }
  }, [onFetchMerchants, page, per_page, search])

  const handlePageChange = (event, newPage) => {
    setPage(newPage)
  }

  const handlePerPageChange = (event) => {
    setPerPage(event.target.value)
  }

  const handleSearchClick = (event, search) => {
    setIsFiltered(true)
    setSearch(search)
  }

  const handleSearchCancelClick = (event) => {
    setIsFiltered(false)
    setSearch('')
  }

  let merchantsTable = (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  )
  if(!loading){
    merchantsTable = (
      <DeletedMerchantsTable
        merchants={merchants}
        pagination={pagination}
        onPageChange={(event, newPage) => handlePageChange(event, newPage)}
        onPerPageChange={handlePerPageChange}
        onSearchClick={(event, search) => handleSearchClick(event, search)}
        onSearchCancelClick={handleSearchCancelClick}
        currentSearch={search}
        isFiltered={isFiltered}
      />
    )
  }
  
  return (
    <div className={classes.root}>
      <div className={classes.content}>
      <AppBar position="static" color="default">
        <Tabs
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          value="0"
        >
          <Tab label="Merchants" href="merchants"/>
          <Tab label="Deleted Merchants" href=""  sx={{
            color: '#fff!important',
            background: '#17507f'
          }} value="0" />
        </Tabs>
      </AppBar>
        
        <Card>
          <Divider />
          {merchantsTable}
        </Card>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    merchants: state.deletedMerchant.merchants,
    loading: state.merchant.loading,
    token: state.auth.token,
    pagination: state.merchant.pagination,
    modalOpen: state.merchant.merchant_delete_modal_open
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchMerchants: (page, per_page, search) => dispatch(actions.fetchDeletedMerchants(page, per_page, search)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(DeletedMerchantList, axios))